import { hyperdbTriggers } from 'hyperdb-utils';
import httpRequest from '../../../helpers/httpRequest';
import { APP_URL } from '../../../../config';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  namespace: 'AVAILABILITIES',
  entryPoint: '/availabilities',
});

export default {
  ...triggers,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/availabilities/triggers.js